import { useLanguage, useSEO } from "../context/LanguageContext";
import { PageHero, SectionHeading, Reveal, CTAButton, Overline } from "../components/Kinetic";

const MissionPage = () => {
  const { t } = useLanguage();
  useSEO(t("mission.metaTitle"), t("mission.metaDesc"));
  const positions = t("mission.positions");
  const principles = t("mission.principles");

  return (
    <div data-testid="mission-page">
      <PageHero
        overline={t("mission.overline")}
        titleLines={t("mission.titleLines")}
        intro={t("mission.intro")}
        testid="mission"
      />

      <section className="py-24 md:py-32">
        <div className="mx-auto max-w-7xl px-6">
          <SectionHeading overline={t("mission.positionOverline")} title={t("mission.positionTitle")} />
          <div className="mt-16 grid gap-px bg-graphite/10 sm:grid-cols-2 lg:grid-cols-5">
            {positions.map((p, i) => (
              <Reveal key={p.title} delay={i * 0.08} className="group bg-bone p-7 transition-colors duration-300 hover:bg-forest">
                <p className="font-mono text-xs text-forest transition-colors duration-300 group-hover:text-white/60">
                  {String(i + 1).padStart(2, "0")}
                </p>
                <h3 className="mt-5 font-display text-xl font-bold uppercase tracking-tight text-graphite transition-colors duration-300 group-hover:text-white">
                  {p.title}
                </h3>
                <p className="mt-3 text-sm leading-relaxed text-graphite-soft transition-colors duration-300 group-hover:text-white/70">
                  {p.text}
                </p>
              </Reveal>
            ))}
          </div>
        </div>
      </section>

      <section className="bg-graphite py-24 text-white md:py-32">
        <div className="mx-auto max-w-7xl px-6">
          <SectionHeading overline={t("mission.principlesOverline")} title={t("mission.principlesTitle")} light />
          <div className="mt-16 grid gap-10 md:grid-cols-2">
            {principles.map((q, i) => (
              <Reveal key={q} delay={i * 0.08}>
                <p className="font-display text-2xl md:text-3xl font-light tracking-tight leading-snug text-white/90">
                  <span className="mr-4 font-mono text-sm text-[#4ADE80]">{String(i + 1).padStart(2, "0")}</span>
                  {q}
                </p>
              </Reveal>
            ))}
          </div>
          <Reveal delay={0.3}>
            <p className="mt-14 max-w-2xl border-l-2 border-[#4ADE80] pl-6 text-sm leading-relaxed text-white/60">
              {t("mission.principlesNote")}
            </p>
          </Reveal>
        </div>
      </section>

      <section className="py-24 text-center-none md:py-32">
        <div className="mx-auto flex max-w-7xl flex-wrap items-center justify-between gap-8 px-6">
          <Reveal>
            <Overline>{t("home.manifestoOverline")}</Overline>
            <p className="mt-4 max-w-2xl font-display text-2xl md:text-4xl font-light tracking-tight text-graphite">
              {t("brand.message")}
            </p>
          </Reveal>
          <Reveal delay={0.15}>
            <CTAButton to="/centre" testid="mission-cta-centre">
              {t("home.centreCta")}
            </CTAButton>
          </Reveal>
        </div>
      </section>
    </div>
  );
};

export default MissionPage;
